import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Table } from "react-bootstrap";
import { compressorNameOrNumber } from "../model/Kompressor.js";
import "./Anlagenpass.css";

const Anlagenpass = props => (
	<div className="Anlagenpass">
		<h1>
			<FormattedMessage id="Compressor" />{" "}
			{compressorNameOrNumber(props.compressor)}
		</h1>
		<Table><tbody>
			<tr>
				<td><FormattedMessage id="Model" /></td>
				<td>{props.compressor.type_plate.model}</td>
			</tr>
			<tr>
				<td><FormattedMessage id="Factory-No." /></td>
				<td>{props.compressor.type_plate.factory_number}</td>
			</tr>
			<tr>
				<td><FormattedMessage id="EDP-No." /></td>
				<td>{props.compressor.type_plate.edp_number}</td>
			</tr>
			<tr>
				<td><FormattedMessage id="Consignment-No." /></td>
				<td>{props.compressor.type_plate.consignment_number}</td>
			</tr>
			<tr>
				<td><FormattedMessage id="Schematic-No." /></td>
				<td>{props.compressor.type_plate.schematic_number}</td>
			</tr>
			<tr>
				<td className="MitAbstand">
					<FormattedMessage id="Software-version" />
				</td>
				<td className="MitAbstand">
					{props.compressor.type_plate.software_version}
				</td>
			</tr>
		</tbody></Table>
	</div>
);

Anlagenpass.propTypes = {
	compressor: PropTypes.object.isRequired
};

export default Anlagenpass;
